import * as yup from 'yup';

const schema = yup.string().trim().url().required();

export const isValidUrl = (url: string) => schema.isValidSync(url);
